export default __webpack_public_path__ + "ec69682ebddcd9921831bfc9d274fec1.svg";